import { Link } from 'react-router-dom';
import { formatBR } from '@control-center/shared';

import { useChargesToday } from '../../hooks/use-dashboard';

const brl = (v: number): string =>
  v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const statusStyles: Record<string, string> = {
  gerada: 'bg-panel-3 text-muted',
  enviada: 'bg-brand-soft text-ink',
  aguardando_pagamento: 'bg-warn/15 text-warn',
  paga: 'bg-good/15 text-good',
  paga_manual: 'bg-good/15 text-good',
  vencida: 'bg-bad/15 text-bad',
  cancelada: 'bg-panel-3 text-muted-2',
  estornada: 'bg-brand-soft text-ink-2',
};

/** Story 6.3 — Cobranças criadas hoje (até 50). */
export function ChargesTodayTable() {
  const query = useChargesToday(50);

  if (query.isLoading) {
    return <div className="h-64 animate-pulse rounded-lg border border-line bg-panel-2" />;
  }

  if (query.isError) {
    return (
      <div className="rounded-lg border border-bad/40 bg-bad/10 p-4 text-sm text-ink">
        Erro ao carregar cobranças do dia.
      </div>
    );
  }

  const items = query.data?.data.items ?? [];
  const total = query.data?.data.total ?? 0;

  return (
    <div className="overflow-hidden rounded-lg border border-line bg-panel">
      <div className="flex items-center justify-between border-b border-line px-4 py-3">
        <h3 className="text-sm font-medium text-ink">Cobranças do dia</h3>
        <span className="text-xs text-muted">{total} no total</span>
      </div>
      {items.length === 0 ? (
        <div className="py-8 text-center text-sm text-muted">
          Nenhuma cobrança gerada hoje ainda.
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="border-b border-line bg-panel-2 text-left text-[11px] uppercase tracking-wider text-muted-3">
              <tr>
                <th className="px-3 py-2 font-medium">Cliente</th>
                <th className="px-3 py-2 text-right font-medium">Valor</th>
                <th className="px-3 py-2 font-medium">Vence</th>
                <th className="px-3 py-2 font-medium">Status</th>
                <th className="px-3 py-2"></th>
              </tr>
            </thead>
            <tbody>
              {items.map((row) => (
                <tr key={row.id} className="border-b border-line last:border-0 hover:bg-panel-2">
                  <td className="px-3 py-2">
                    <Link to={`/clients/${row.client_id}`} className="text-ink hover:underline">
                      {row.client_name}
                    </Link>
                  </td>
                  <td className="px-3 py-2 text-right font-mono tabular-nums text-ink">
                    {brl(row.amount)}
                  </td>
                  <td className="px-3 py-2 text-muted">{formatBR(row.due_date)}</td>
                  <td className="px-3 py-2">
                    <span
                      className={`rounded px-2 py-0.5 text-xs font-medium ${
                        statusStyles[row.status] ?? 'bg-panel-3 text-muted'
                      }`}
                    >
                      {row.status}
                    </span>
                  </td>
                  <td className="px-3 py-2 text-right">
                    <Link
                      to={`/charges/${row.id}`}
                      className="text-xs font-medium text-brand hover:underline"
                    >
                      detalhe →
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
